<template>
    <div>
        <v-card>
            <v-card-title>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loading" :headers="headers" :items="items" :search="search" must-sort>
                    <template v-slot:items="props">
                        <tr :style="'background-color: ' + ranks[props.item.rank].color">
                            <td class="text-xs-left">{{props.item.id}}</td>
                            <td class="text-xs-left">{{props.item.name}}</td>
                            <td class="text-xs-left">{{props.item.rating.toFixed(2)}}</td>
                            <td class="text-xs-left">{{(props.item.acceptance_ratio*100).toFixed(2)}} %</td>
                            <td class="text-xs-left">{{(props.item.cancellation_ratio*100).toFixed(2)}} %</td>
                            <td class="text-xs-left">{{ranks[props.item.rank].text}}</td>

                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

    </div>
</template>

<script>

    export default {
        title: "Captain Acceptance Ratio",
        name: "acceptance-ratio",
        computed: {
            ranks() {
                return[
                    {text: "under_low", color: "#F05354"},
                    {text: "low", color: "#AAAAAA"},
                    {text: "medium", color: "#FFC107"},
                    {text: "high", color: "#4BBD98"}
                ]
            },
            headers() {
                return [
                    {value: "id", text: "#"},
                    {value: "name", text: "Name"},
                    {value: "rating", text: "Rating"},
                    {value: "acceptance_ratio", text: "Acceptance Ratio"},
                    {value: "cancellation_ratio", text: "Cancellation Ratio"},
                    {value: "rank", text: "Rank"},
                ];
            }
        },
        data() {
            return {
                loading: false,
                items: [],
                search: "",
                mins: {}
            }
        },
        methods: {
            rank(item) {
                /** From Captain App
                 * boolean top = data.getCaptainRating() >= data.getMinRatingToSeeDestination() && data.getCaptainRatio() >= data.getMinRatioToSeeDestination();
                 * boolean medium = data.getCaptainRating() >= data.getMinRatingToAcceptOrders() && data.getCaptainRatio() >= data.getMinRatioToAcceptOrders();
                 * high : #4BBD98
                 * medium : yellow  = #FFC107
                 * low : gray = #AAAAAA
                 * under low : red = #F05354
                 * boolean underlow = data.getCancellationRatio() > data.getMin_cancellation_ratio();
                 * if (underlow) {
                 *   color =underlow
                 * }  else if (high) {
                 *     color = high;
                 * } else if  (medium) {
                 *     color =medium
                 * } else {
                 *     color = low
                 * }
                 */
                const rating = Number(item.rating);
                const acceptance_ratio = Number(item.acceptance_ratio);
                const cancellation_ratio = Number(item.cancellation_ratio);
                const {
                    min_rating_to_accept_orders,
                    min_rating_to_see_destination,
                    min_ratio_to_accept_orders,
                    min_ratio_to_see_destination,
                    min_cancellation_ratio
                } = this.mins;

                const top = rating >= min_rating_to_see_destination && acceptance_ratio >= min_ratio_to_see_destination;
                const medium = rating >= min_rating_to_accept_orders && acceptance_ratio >= min_ratio_to_accept_orders;
                const under_low = cancellation_ratio > min_cancellation_ratio;

                if (under_low) {
                    return 0;
                    return "#F05354";
                } else if (top) {
                    return 3;
                    return "#4BBD98";
                } else if (medium) {
                    return 2;
                    return "#FFC107";
                } else {
                    return 1;
                    return "#AAAAAA";
                }
            },
            async getData() {
                this.loading = true;
                try {
                    const params = new URLSearchParams();
                    params.append("start", moment(this.start).format("YYYY-MM-DD 00:00:00"));
                    params.append("end", moment(this.end).format("YYYY-MM-DD 23:59:59"));
                    const x = await this.axios.get(this.api.ACTIONS.CAPTAIN_ACCEPTANCE_RATIO);
                    this.mins = x.data.data.mins;
                    this.items = x.data.data.captains.map(x => {
                        return {...x, rank: this.rank(x)}
                    });
                } catch (e) {

                } finally {
                    this.loading = false;
                }
            }
        },
        mounted() {
            this.getData();
        }

    }
</script>

<style scoped>

</style>
